import { render } from "./OuterMetadataInputPage.vue?vue&type=template&id=78df9b52&scoped=true&ts=true"
import script from "./OuterMetadataInputPage.vue?vue&type=script&lang=ts"
export * from "./OuterMetadataInputPage.vue?vue&type=script&lang=ts"

import "./OuterMetadataInputPage.vue?vue&type=style&index=0&id=78df9b52&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78df9b52"]])

export default __exports__